<template lang="html">

  <section class="payments">
    <div class="pageHeading">
        <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex xs11>
                    <h2>Forms</h2>
                </v-flex>
                <v-flex xs1>
                    <v-btn @click="newForm" color="primary"  v-if="editingForm == null"
                           small dark>New Form</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </div>

      <v-container v-if="editingForm == null">
          <v-data-table :headers="headers" :items="forms"
          >
              <template slot="items" slot-scope="props">
                  <tr>
                      <td>{{ props.item.name }}</td>
                      <td class="text-xs-left">{{ props.item.lastEdit | moment("MM/DD/YYYY")}}</td>
                      <td>
                          <v-btn @click="editingForm = props.item" color="primary"
                                  small dark>Edit Document</v-btn>
                      </td>

                  </tr>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ search }}" found no results.
              </v-alert>
          </v-data-table>
      </v-container>

      <v-container v-else>

          <v-dialog v-model="preview" transition="dialog-bottom-transition" max-width="90%" >

              <v-card>

              <v-container >
                  <v-layout  row wrap >
              <v-flex xs12><h2>{{editingForm.name}}</h2><hr/></v-flex>

              <sign-document :formdocument="editingForm" preview="true">

              </sign-document>
                  </v-layout>
              </v-container>

              </v-card>
          </v-dialog>
          <v-layout  row wrap >

              <v-flex xs12>
              <v-card elevation="1">
                  <v-card-title primary-title>
                      <v-flex xs8><h2>{{editingForm.name}}</h2></v-flex>
                      <v-flex xs4> <v-btn color="primary" @click="saveForm"
                                          small dark>Save</v-btn>
                          <v-btn color="secondary" @click.stop="preview = true"
                                 small dark>Preview</v-btn>
                          <v-btn color="secondary" @click="editingForm = null"
                                 small dark>Back</v-btn></v-flex>
                  </v-card-title>
                  <v-container style="border-top: lightgray 1px solid;
    cursor: pointer;"  >

                  <v-layout row wrap>
                      <v-flex xs12>
                          <v-text-field
                                  v-model="editingForm.name"
                                  label="Form Name"
                                  required
                          ></v-text-field></v-flex>
                      <v-flex xs12>
                          <froala :tag="'textarea'" v-model="editingForm.content">Init text</froala>
                      </v-flex>
                  </v-layout>
                  </v-container>
              </v-card>
              </v-flex>

          </v-layout>


      </v-container>
  </section>
</template>

<script lang="js">
    import signDocument from '../components/SignDocument'
  export default  {
    name: 'payments',
    props: [],
    mounted() {
        var vueThis = this
        this.$services.forms.find().then((result) => {
            vueThis.forms = result.data
            console.log('got the forms', result)
        })
    },
    data() {
      return {
          editingForm: null,
          preview: false,
          forms: [],
          headers: [
              {
                  text: 'Form Name',
                  align: 'left',
                  sortable: false,
                  value: 'name',
              },
              { text: 'Last Edit',
                  align: 'left',
                  sortable: true,
                  value: 'lastEdit' },
              {
                  text: '',
              }
          ]
      }
    },
      components: {
          signDocument: signDocument
      },
    methods: {
        newForm() {
            this.editingForm = {
                name: '',
                content: ''

            }
        },
        saveForm() {
            var vueThis = this
            if(this.editingForm._id == undefined) {
                this.$services.forms.create(this.editingForm).then((result) => {
                    console.log('test', result)
                    this.editingForm = result
                    this.forms.push(result)
                    vueThis.$emit("alertUser", "success", "Form (" + this.editingForm.name + ") Created!!")

                }).catch(function(error){
                    vueThis.$emit("alertUser", "error", "Sorry, there was an error processing your request. Please try again later.")
                    console.error('Error!', error);
                });
            } else {
                this.$services.forms.patch(this.editingForm._id, this.editingForm).then((result) => {
                    console.log(' update result', result)

                    vueThis.$emit("alertUser", "success", "Form Updated!!")
                }).catch(function(error){
                    console.error('update Error!', error);
                    vueThis.$emit("alertUser","error", "Sorry, there was an error processing your request. Please try again later.")

                });
            }

        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
  .forms {
      .v-dialog {
          background-color: white !important;
      }
  }
</style>
